var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2961_11389)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2961_11389)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2961_11389)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57507 2.39355C7.02279 2.39355 6.57507 2.84127 6.57507 3.39355V20.3936C6.57507 20.9458 7.02279 21.3936 7.57507 21.3936H20.5751C21.1274 21.3936 21.5751 20.9458 21.5751 20.3936V7.91987H19.0658C17.409 7.91987 16.0658 6.57673 16.0658 4.91987V2.39355H7.57507ZM18.0658 3.81306L20.1661 5.91987H19.0658C18.5135 5.91987 18.0658 5.47216 18.0658 4.91987V3.81306ZM4.57507 3.39355C4.57507 1.7367 5.91822 0.393555 7.57507 0.393555H17.4809L23.5751 6.50656V20.3936C23.5751 22.0504 22.2319 23.3936 20.5751 23.3936H7.57507C5.91822 23.3936 4.57507 22.0504 4.57507 20.3936V3.39355Z",
    fill: "#5C6773"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2.57507 8.19336C2.57507 7.36493 3.24665 6.69336 4.07507 6.69336H14.0751C14.9035 6.69336 15.5751 7.36493 15.5751 8.19336V11.4934C15.5751 12.3218 14.9035 12.9934 14.0751 12.9934H4.07507C3.24665 12.9934 2.57507 12.3218 2.57507 11.4934V8.19336Z",
    fill: "#5C6773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9538 11.3935V8.48438H6.04471C6.26819 8.48438 6.45569 8.52604 6.60721 8.60938C6.75967 8.69271 6.87472 8.80729 6.95238 8.95312C7.03097 9.09801 7.07027 9.26278 7.07027 9.44744C7.07027 9.634 7.03097 9.79972 6.95238 9.9446C6.87378 10.0895 6.75777 10.2036 6.60436 10.2869C6.45096 10.3693 6.26204 10.4105 6.0376 10.4105H5.31459V9.97727H5.96658C6.09726 9.97727 6.20427 9.95455 6.2876 9.90909C6.37094 9.86364 6.43249 9.80114 6.47226 9.72159C6.51298 9.64205 6.53334 9.55066 6.53334 9.44744C6.53334 9.34422 6.51298 9.25331 6.47226 9.17472C6.43249 9.09612 6.37046 9.03504 6.28618 8.99148C6.20285 8.94697 6.09537 8.92472 5.96374 8.92472H5.48079V11.3935H4.9538Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01381 11.3935H8.02802V8.48438H9.0337C9.32252 8.48438 9.57063 8.54261 9.77802 8.65909C9.98635 8.77462 10.1464 8.94081 10.2581 9.15767C10.3699 9.37453 10.4257 9.634 10.4257 9.93608C10.4257 10.2391 10.3694 10.4995 10.2567 10.7173C10.145 10.9351 9.98351 11.1023 9.77233 11.2188C9.56211 11.3352 9.30926 11.3935 9.01381 11.3935ZM8.555 10.9375H8.98824C9.19089 10.9375 9.35993 10.9006 9.49534 10.8267C9.63076 10.7519 9.73256 10.6406 9.80074 10.4929C9.86892 10.3442 9.90302 10.1586 9.90302 9.93608C9.90302 9.71354 9.86892 9.52888 9.80074 9.3821C9.73256 9.23437 9.63171 9.12405 9.49819 9.05114C9.36561 8.97727 9.20084 8.94034 9.00387 8.94034H8.555V10.9375Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4265 11.3935V8.48438H13.2901V8.92614H11.9534V9.71591H13.1622V10.1577H11.9534V11.3935H11.4265Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57507 15.6436C8.57507 15.2293 8.91086 14.8936 9.32507 14.8936L18.8251 14.8936C19.2393 14.8936 19.5751 15.2293 19.5751 15.6436C19.5751 16.0578 19.2393 16.3936 18.8251 16.3936L9.32507 16.3936C8.91086 16.3936 8.57507 16.0578 8.57507 15.6436Z",
    fill: "#5C6773"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57507 18.6436C8.57507 18.2293 8.91086 17.8936 9.32507 17.8936L15.8251 17.8936C16.2393 17.8936 16.5751 18.2293 16.5751 18.6436C16.5751 19.0578 16.2393 19.3936 15.8251 19.3936L9.32507 19.3936C8.91086 19.3936 8.57507 19.0578 8.57507 18.6436Z",
    fill: "#5C6773"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2961_11389",
    x: -25.4249,
    y: -27.6064,
    width: 83,
    height: 87,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2961_11389"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2961_11389",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2961_11389",
    x: -10.4249,
    y: -17.6064,
    width: 51,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2961_11389"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2961_11389",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2961_11389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.575073 0.393555)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.e32f01e757dae7a506ef4b147a4c2578.svg";
export { ForwardRef as ReactComponent };